export type CookieConsent = {
  analytics: boolean;
  decidedAt: string;
  version: number;
};

const STORAGE_KEY = 'cookie_consent';
const CONSENT_VERSION = 1;

export const COOKIE_CONSENT_CHANGE_EVENT = 'cookie-consent-change';
export const COOKIE_SETTINGS_OPEN_EVENT = 'cookie-settings-open';

// Device-level choice: deliberately not in purgeSession, so it survives logout.
export const getCookieConsent = (): CookieConsent | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as CookieConsent;
    if (parsed?.version !== CONSENT_VERSION) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const setCookieConsent = (analytics: boolean): CookieConsent => {
  const consent: CookieConsent = {
    analytics,
    decidedAt: new Date().toISOString(),
    version: CONSENT_VERSION,
  };

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
  } catch {
    // Storage blocked: the choice still applies for this page view.
  }

  window.dispatchEvent(
    new CustomEvent<CookieConsent>(COOKIE_CONSENT_CHANGE_EVENT, {
      detail: consent,
    }),
  );

  return consent;
};

export const openCookieSettings = (): void => {
  window.dispatchEvent(new Event(COOKIE_SETTINGS_OPEN_EVENT));
};
